import {
  enumObjectTypes,
  kDivisionID,
  kEmployeeID,
  kHeadcount,
  kNameID,
  kPersonID,
  kPhotoID,
  kPositionDivisionID,
  kPositionID,
  kPositionTitleID,
  kTitleID
} from "@coreapp/constants";

export const getMainDisplayFieldIds = (
  isPositionDoc: boolean,
  objType: string
): Record<string, string> => {
  if (isPositionDoc) {
    if (objType === enumObjectTypes.position) {
      return {
        name: kPositionTitleID,
        id: kPositionID,
        dept: kPositionDivisionID,
        headcount: kHeadcount
      };
    }

    return {
      name: kNameID,
      id: kEmployeeID,
      title: kTitleID,
      dept: kDivisionID,
      photo: kPhotoID
    };
  }

  return {
    name: kNameID,
    id: kPersonID,
    title: kTitleID,
    dept: kDivisionID,
    photo: kPhotoID
  };
};
